




import AdminSettingsFeatures from '@/components/Templates/Admin/Settings/Features/Features.vue';

export default {
    name: 'AdminSettingsFeaturesView',
    components: {
        AdminSettingsFeatures,
    },
};
